$(document).on('turbolinks:load', function() {
  // toggle interest
  $('#js-interests').on('click', '.js-interest', function(e){
    e.preventDefault();

    Interest.toggle($(this));

    $('.js-save-message').show();

    e.stopPropagation();
  });

  $('.js-clear-all').on('click', (e) => {
    Interest.clearAll();

    $('.js-save-message').show();
  });
});

var Interest = {
  toggle: function(item){
    var toggleUrl = $('#js-interest-route').attr('data-route');
    toggleUrl = toggleUrl.replace('__INTEREST_ID__', item.attr('data-id'));

    $.ajax({
      type: "GET",
      url: toggleUrl,
      success: function(data) {
        // update list
        Interest.updateList(data.items);
      }
    });
  },

  updateList: function(items) {
    $('#js-interest-list').empty();
    $('.js-interest-badge').remove();

    // remove all active states from dropdown menu
    $('.js-interest').each((i, item) => {
      $(item).removeClass('list-group-item-success');
    });

    var count = 0;

    $.each(items, function(i, userInterest) {
      count++;

      // add to interest list
      $('#js-interest-list').append(`<span class="badge badge-secondary} ml-1 mb-2">${userInterest.name} <a class="js-interest cursor-pointer" data-id="${userInterest.id}"><span class="fas fa-times-circle"></span></a></span>`)

      // dropdown item to active
      var interest = $(`.dropdown-item[data-id='${userInterest.id}']`);
      $(interest).addClass('list-group-item-success');
      $(interest).append('<span class="badge badge-success js-interest-badge float-right" style="font-size: 0.65rem;">Added!</span>');
    });

    if (count == 0) {
      $('#js-interest-list').append('Select areas of interest above.');
      $('.js-clear-all').hide();
    } else {
      $('.js-clear-all').show();
    }
  },

  clearAll: function() {
    var clearAllUrl = $('#js-interest-route').attr('data-clear-route');

    $.ajax({
      type: "GET",
      url: clearAllUrl,
      success: function(data) {
        // update list
        Interest.updateList(data.items);
      }
    });
  }
}
